import React, { Component } from "react";
import { connect } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { bool, number, shape } from "prop-types";
import classNames from "classnames";
import * as configUtils from "util/config";
import { MAX_FAILED_TIMES } from "constants.js";
import MainContainer from "pages/_components/MainContainer";
import { selectors as i18nSelectors } from "reducers/i18n";
import { selectors as configSelectors } from "reducers/config";
import { selectors as sessionSelectors } from "reducers/session";

import Routes from "routes/Routes";

import gaEventTracker from "util/gaEventTracker";
import KonectaWidget from "pages/_components/KonectaWidget";

/* eslint-disable react/jsx-filename-extension */
class App extends Component {
    static propTypes = {
        loading: bool,
        timesConfigFailed: number,
        timesI18nFailed: number,
        history: shape({}).isRequired,
    };

    static defaultProps = {
        loading: false,
        timesConfigFailed: 0,
        timesI18nFailed: 0,
    };

    componentDidMount() {
        const gaTrackingID = configUtils.get("frontend.analytics.trackingID", null);
        if (gaTrackingID != null) {
            gaEventTracker.init(gaTrackingID);
        }
    }

    render() {
        const { loading, activeEnvironment, userName, timesConfigFailed, timesI18nFailed, history,isLoggedIn } = this.props;

        const serverError = timesConfigFailed >= MAX_FAILED_TIMES || timesI18nFailed >= MAX_FAILED_TIMES;

        if (loading && !serverError) {
            return (
                <div className="view-page">
                    <div className="view-content">
                        <MainContainer showLoader className={classNames("main-container")} />
                    </div>
                </div>
            );
        }
        let loggedUser= "";
        if(isLoggedIn && activeEnvironment){
            loggedUser=`Usuario: ${userName} - ${activeEnvironment.userDocument ? activeEnvironment.userDocument : ""} Empresa: ${activeEnvironment.name} - ${activeEnvironment.activeEnvironmentDocument ? activeEnvironment.activeEnvironmentDocument : ""}`;
        }

        return (
            <ConnectedRouter history={history}>
                <Routes />
                <KonectaWidget loggedUser={loggedUser} />
            </ConnectedRouter>
        );
    }
}

const mapStateToProps = ({ isLoading, ...state }) => ({
    loading: isLoading || !i18nSelectors.getMessages(state) || !configSelectors.getConfig(state),
    timesConfigFailed: configSelectors.getTimesFailed(state),
    timesI18nFailed: i18nSelectors.getTimesFailed(state),
    isLoggedIn: sessionSelectors.isLoggedIn(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    userName: sessionSelectors.getUserFullName(state),
});

export default connect(mapStateToProps)(App);
